import React, { useMemo } from "react";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import { useQuery, QueryResponseHandler } from "components/graphql";
import { SourceData, getSourceQuery } from "./details-page";
import { WarningActiveEvent, SourceChange, SourceDataViewer } from "./viewer-page";
import DataGrid, { DataGridItem } from "components/data-grid";

const SourceViewerPage = ({
  match: {
    params: { id },
  },
}) => {
  const query = useMemo(() => getSourceQuery(id), [id]);
  const { data, loading, error } = useQuery(query);

  const source = data.source;

  return (
    <Dashboard>
      <QueryResponseHandler error={error} loading={loading} elements={source}>
        <PageHeaderBar showBackButton title="app.page.source" />
        <PageSection>
          <WarningActiveEvent source={source}>
            {source && source.type === "camera" && <SourceDataViewer source={source} />}
          </WarningActiveEvent>
          <DataGrid>
            <DataGridItem>
              <SourceChange source={source} />
            </DataGridItem>
          </DataGrid>
        </PageSection>
        <PageSection spaced>
          <SourceData source={source} showCamera={false} />
        </PageSection>
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default SourceViewerPage;
